module.exports = __webpack_public_path__ + "src/assets/sounds/spray_sound.mp3";